import template from './index.html'

let _C = [], N = 0;

const NF = 30,
  TFN = {
    'linear': function (k) { return k },
    'ease-in': function (k, e = 1.675) {
      return Math.pow(k, e)
    },
    'ease-out': function (k, e = 1.675) {
      return 1 - Math.pow(1 - k, e)
    },
    'ease-in-out': function (k) {
      return .5 * (Math.sin((k - .5) * Math.PI) + 1)
    },
    'bounce-out': function (k, a = 2.75, b = 1.5) {
      return 1 - Math.pow(1 - k, a) * Math.abs(Math.cos(Math.pow(k, b) * (n + .5) * Math.PI))
    }
  };

let i = 0, x0 = null, locked = false, w, ini, fin, rID = null, anf, n;

const DATE_FORMAT = 'DD.MM.YYYY'

const pagePlayback = () => {
  let isReady = false
  return {
    list: [],
    playbackBody: null,
    root: null,
    time: '00:00:00',
    camera: null,
    device: null,
    players: [],
    date: null,
    timeline: null,
    title: '',
    path: '',
    showControls: true,
    onSlide: 1,
    currentSlide: 0,
    isPlaying: false,
    datepicker: null,
    async init() {
      this.root = this
      this.timeline = this.app.components.timeline({
        onMove: t => this.onTimelineMove(t),
        onChange: _ => this.onTimelineChange()
      })
      this.datepicker = this.app.components.datepicker({setDate: value => {
          this.date = value
          this.timeline.setDate(dayjs(this.date, DATE_FORMAT).valueOf(), dayjs(this.date, DATE_FORMAT).add(1, 'day').valueOf())
          if (isReady) this.playbackFiles()
      }, format: DATE_FORMAT})
      this.device = this.app.context.device
      this.camera = this.device.cameras[this.app.context.cameraIndex]
      this.path = this.app.context.path
      this.title = 'Архив ' + this.camera.name
      console.log({
        ah: window.screen.availHeight,
        aw: window.screen.availWidth,
        h: window.screen.height,
        w: window.screen.width,
        pr: window.devicePixelRatio
      })

      /*Array.from(Array(this.device.cameras.length).keys()).forEach(i => {
        this.players.push(this.app.components.player({
          id: i + 100,
          attrClass: 'bg-black',
          camera: this.device.cameras[i],
          device: this.app.context.device,
          path: this.app.context.path
        }))
      })*/
      this.players.push(this.app.components.player({
        id: i + 100,
        attrClass: 'bg-black',
        camera: this.camera,
        device: this.app.context.device,
        path: this.app.context.path
      }))
      N = Math.ceil(this.device.cameras.length / this.onSlide)

      this.callIOS('setCamGridParams', { params: [['width', 32 * window.innerHeight], ['height', 'auto']] })
      this.app.on('orientation', this.changeOrientation, this)

      this.players[0].on('ready', _ => {
        isReady = true
        this.playbackFiles()
      })

      this.root = this

      console.log('Page playback!')
      this.$nextTick(_ => {
        this.$el.innerHTML = template
        this.$nextTick(_ => {
          _C = document.querySelector('.cam-grid-playback')
          _C.style.setProperty('--n', N)
          this.changeOrientation(this.app.orientation)
        })
      })

      //await this.updateVideoSize()
      //this.dvripPlaybackFiles()
    },
    makeSlides() {
      this.size()
      const screenWidth = this.app.orientation == 'portrait' ? window.screen.width : window.screen.height
      const screenHeight = this.app.orientation == 'portrait' ? window.screen.height : window.screen.width

      this.players.forEach(async player => {
        const slide = Math.floor((player.id -100) / this.onSlide)
        const num = player.id -100 - Math.floor((player.id -100) / this.onSlide) * this.onSlide
        let ww = 0
        let hh = 0
        switch (this.onSlide) {
          case 1:
            ww = screenWidth
            hh = this.app.orientation == 'portrait' ? 300 : screenHeight
            await player.setTop(0)
            await player.setLeft(screenWidth * slide + num * ww)
            await player.setWidth(ww)
            await player.setHeight(hh)
            break
          case 4:
            ww = screenWidth / 2
            hh = this.app.orientation == 'portrait' ? 150 : screenHeight / 2
            if (num >= 2) {
              await player.setTop(hh)
              await player.setLeft(screenWidth * slide + (num - 2) * ww)
            } else {
              await player.setTop(0)
              await player.setLeft(screenWidth * slide + num * ww)
            }
            await player.setWidth(ww)
            await player.setHeight(hh)
            break
          case 9:
            ww = screenWidth / 3
            hh = 100
            if (num >= 6) {
              await player.setTop(hh * 2)
              await player.setLeft(screenWidth * slide + (num - 6) * ww)
            } else if (num >= 3) {
              await player.setTop(hh)
              await player.setLeft(screenWidth * slide + (num - 3) * ww)
            } else {
              await player.setTop(0)
              await player.setLeft(screenWidth * slide + num * ww)
            }
            await player.setWidth(ww)
            await player.setHeight(hh)
            break
        }
      })

      _C.style.setProperty('--n', N)
      _C.style.setProperty('--i', i);
      window._app.callIOS('setScrollOffset', i * w)
    },
    async changeOrientation(orientation) {
      if (orientation == 'portrait') {
        //await this.callIOS('setSafeParams', { params: [['marginTop', '1px'], ['width', '1px'], ['height', 48]] })
      } else {
        //await this.callIOS('setSafeParams', { params: [['marginTop', 0], ['width', 0], ['height', 0]] })
      }
      //await this.players[0].setWidth(orientation == 'portrait' ? window.screen.width : window.screen.height)
      //await this.players[0].setHeight(orientation == 'portrait' ? window.screen.height / 3 : window.screen.width)
      this.makeSlides()
    },
    getSlidePlayers() {
      let players = []
      const start = this.currentSlide * this.onSlide
      for (let i = start; i < start + this.onSlide; i++) {
        if (i >= this.device.cameras.length) break
        players.push(i)
      }
      return players
    },
    toggleControls() {
      this.showControls = !this.showControls
    },
    navigatedFrom() {
      console.log('playback closed')
      this.players = []
    },
    navigatedTo() {
      this.root.app.pages.forEach(page => {
        if (page.context.id != 'playback') page.context.class = 'hidden'
      })
      this.players.forEach(player => {
        player.attrClass = ''
      })
    },
    navigatingFrom() {
      this.root.app.pages.forEach(page => {
        if (page.context.id == 'camera') page.context.class = ''
      })
    },
    deactivating() {
      console.log('deactivating playback')
      this.stop()
    },
    async stop() {
      this.isPlaying = false
      this.players.forEach(player => {
        player.stop()
      })
    },
    onTimelineMove(t) {
      this.time = t.toTimeString().split(' ')[0]
    },
    async play() {
      this.isPlaying = true
      const date = dayjs(this.date, DATE_FORMAT).format('YYYY-MM-DD')
      this.players[0].playback({
        id: this.players[0].id,
        BeginTime: date + ' ' + this.time,
        EndTime: date + ' 23:59:59',
        FileName: '',
        stream: this.camera.channel-1,
        path: this.path + '/100.h264',
        formatOpts: this.device.formatOpts
      })
    },
    async onTimelineChange() {
      console.log('onTimelineChange')
      console.log(this.time)
      //if (this.players[0].playing) await this.stop()
      this.players.forEach(player => {
        player.stop()
      })
      this.isPlaying = false
    },
    async playbackFiles() {
      const date = dayjs(this.date, DATE_FORMAT).format('YYYY-MM-DD')
      const files = await this.players[0].playbackFiles({
        id: this.players[0].id,
        channel: this.camera.channel,
        BeginTime: date + ' ' + this.time,
        EndTime: date + ' 23:59:59',
      })

      const data = files.map(item => {
        return {
          b: dayjs(item.BeginTime).valueOf(),
          e: dayjs(item.EndTime).valueOf()
        }
      })

      this.timeline.update(data)
    },
    stopAni() {
      console.log('stpAni!!!!!!!!')
      console.log(i)
      if (this.currentSlide != i) {
        this.isPlaying = false
        this.players.forEach(player => {
          player.stop()
        })
      }
      this.currentSlide = i
      cancelAnimationFrame(rID);
      rID = null
    },
    ani(cf = 0) {
      if (anf == 0) return
      const i = anf > 0 ? ini + (fin - ini) * TFN['ease-out'](cf / anf) : 0
      window._app.callIOS('setScrollOffset', i * w)

      _C.style.setProperty('--i', i);

      if (cf === anf) {
        this.stopAni()
        return
      }

      cf += 1
      rID = requestAnimationFrame(this.ani.bind(this, cf))
    },
    unify(e) { return e.changedTouches ? e.changedTouches[0] : e },
    size() { w = this.app.orientation == 'portrait' ? window.screen.width : window.screen.height },
    lock(e) {
      x0 = this.unify(e).clientX;
      locked = true
    },
    drag(e) {
      e.preventDefault()

      if (locked) {
        let dx = this.unify(e).clientX - x0
        let f = +(dx / w).toFixed(2)
        let ii = i - f
        if (ii < 0) {
          ii = 0
          locked = false
        }
        if (ii > N - 1) {
          ii = N - 1
          locked = false
        }
        window._app.callIOS('setScrollOffset', ii * w)
        _C.style.setProperty('--i', ii)
      }
    },
    move(e) {
      if (locked) {
        console.log(i)
        let dx = this.unify(e).clientX - x0
        let s = Math.sign(dx)
        let f = +(s * dx / w).toFixed(2)

        ini = i - s * f

        if ((i > 0 || s < 0) && (i < N - 1 || s > 0) && f > .2) {
          i -= s;
          f = 1 - f
        }

        fin = i;
        anf = Math.round(f * NF)
        n = 2 + Math.round(f)
        this.ani()
        x0 = null
        locked = false
      }
    }
  }
}

export { pagePlayback }